<template>
  <router-view />
</template>

<script>
export default {
  name: 'EquipmentStorageRentalItemsIndex'
}
</script>
